<template>
  <div
    class="bg-white shadow-md p-3 border-1 text-sm font-bold"
  >
    <div class="text-center">
      <table class="table-auto w-full">
        <thead>
          <tr>
            <td class="border border-gray-400 p-1"></td>
            <td class="border border-gray-400 p-1">2</td>
            <td class="border border-gray-400 p-1">3</td>
            <td class="border border-gray-400 p-1">4</td>
            <td class="border border-gray-400 p-1">5</td>
            <td class="border border-gray-400 p-1">6</td>
            <td class="border border-gray-400 p-1">7</td>
            <td class="border border-gray-400 p-1">8</td>
            <td class="border border-gray-400 p-1">9</td>
            <td class="border border-gray-400 p-1">10</td>
            <td class="border border-gray-400 p-1">A</td>
          </tr>
        </thead>

        <tbody>
          <tr v-for="(value, name) in table">
            <td class="border border-gray-400 p-1">{{ name }}</td>
            <td
              class="border border-gray-400 p-1"
              v-bind:class="{ 'bg-blue-500': rowValue.active }"
              v-for="(rowValue, rowName) in value"
            >
              {{ rowValue.value }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import store from "../store";

export default {
  name: "BlackjackChart",
  store,
  computed: {
    table() {
      return this.$store.getters.charts;
    },
    dealerLastCard() {
      return this.$store.getters.dealerLastCard;
    },
    playerTotal() {
      return this.$store.getters.playerTotalCardsValue;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/BlackjackChart.vue